// export const baseUrl = "https://cors.ebapay.ir/https://client.api.evipclub.ir";
// export const imageBaseUrl = "https://cors.ebapay.ir/https://client.api.evipclub.ir";

// export const baseUrl = 'https://client.api.evipclub.org';
export const imageBaseUrl = 'https://client.api.evipclub.ir';
export const baseUrl = 'https://api.test.evipclub.org';
// export const baseUrl = "http://152.89.45.110:3000";

// 152.89.45.110
const routes = {
  // Login endpoints
  userAuth: baseUrl + '/user/auth',
  verifyOtp: baseUrl + '/user/verify-otp',
  verify: baseUrl + '/user/login',
  logout: baseUrl + '/user/logout',
  resetPass: baseUrl + '/user/reset-password',
  passLogin: baseUrl + '/user/login',
  auth: baseUrl + '/auth',
  referralCode: baseUrl + '/user/setReferral',

  userInfo: baseUrl + '/user',
  category: baseUrl + '/category/user',

  financier: baseUrl + '/financier/user/?number=3',
  allFinanciers: baseUrl + '/financier/user',
  credit: baseUrl + '/credit/user',

  topMerchant: baseUrl + '/merchant/user/top/?number=3',
  merchants: baseUrl + '/merchant/user',
  viewSubscriptons: baseUrl + '/subscription',
  getFinanciers: baseUrl + '/credit/user',
  getFinanciersById: baseUrl + '/credit',
  buySubscribtion: baseUrl + '/user/subscribe',
  userTransaction: baseUrl + '/transaction/user',
  purchaseById: baseUrl + '/purchase',
  verifyPayment: baseUrl + '/user/subscribe/payment/verify/user',

  reserveCharge: baseUrl + '/simcard/charge/reserve',
  reserveCahrgeGuest: baseUrl + '/simcard/charge/guest-reserve',
  internetPackages: baseUrl + '/simcard/internet/packages',
  reserveInternet: baseUrl + '/simcard/internet/reserve',
  reserveInternetGuest: baseUrl + '/simcard/internet/guest-reserve',

  videos: baseUrl + '/video',
  uploadNationalCard: baseUrl + '/user/national-card',
  subscriptions: baseUrl + '/subscription',
  wallet: baseUrl + '/user/wallet',
  nationalCard: baseUrl + '/user/national-card',
  activeWallet: baseUrl + '/user/activate-wallet',
  cardEnroll: baseUrl + '/shaparak/card/enroll',
  cardVerifyInformation: baseUrl + '/shaparak/card/verify/information',
  allCards: baseUrl + '/shaparak/all/enrollments',
  deleteCard: baseUrl + '/shaparak/card',
  loans: baseUrl + '/loan/user',
  destinationPans: baseUrl + '/shaparak/history/destination-pans',
  allTransactionHis: baseUrl + '/shaparak/all/transactions',
  preRegisterPhoneNumber: baseUrl + '/landingpage/pre-register',
  leadAdd: baseUrl + '/lead/add',

  // ======================  Police   ======================
  // Lisence plate
  license: baseUrl + '/naja/driving-licenses/gateway',
  negativePoints: baseUrl + '/naja/negative-points/gateway',
  licenseAndNegativePoints:
    baseUrl + '/naja/driving-licenses/negative-points/gateway',
    
  verifyLoginless: baseUrl + '/transaction/verify/user/loginless',

  // Violation
  licensePlate: baseUrl + '/naja/license-plates/gateway',
  platesList: baseUrl + '/naja/license-plates/saved',
  najaGetPlate: baseUrl + '/naja/license-plates/gateway',
  violation: baseUrl + '/naja/violations/gateway',
  document: baseUrl + '/naja/document/gateway',

  // Bill payment url
  billPayment: baseUrl + '/bill/init/payment-gateway',

  // transaction
  transactionSmsCancel: baseUrl + '/transaction/sms/cancel',
  transactionSaveInfo: baseUrl + '/transaction/save/info/cancel',

  // uid
  uidVideo: baseUrl + '/uid/all/init/payment-gateway',

  // home services
  gapFilm: baseUrl + '/gapfilm',

  // investments
  investments: baseUrl + '/hamafarin',

  // Dapp
  creditRegister: baseUrl + '/credit/user/register',
};

export default routes;
